<template>
  <section class="tools">
    <div class="tools-favorite" v-if="favoriteVisible">
      <button class="tools-favorite__item active" title="已收藏" @click="$emit('unFavorite')" v-if="isFavorite">
        <i class="yk-collection-o"></i>
      </button>
      <button class="tools-favorite__item" title="收藏" @click="$emit('favorite')" v-else>
        <i class="yk-home_collection"></i>
      </button>
      <div class="tools-favorite__num" :class="{ active: isFavorite }">{{ favoriteNum }}</div>
    </div>
    <ul class="tools-list">
      <li class="tools-item" v-if="wechatShareVisible">
        <YorkbbsWechatSharePopover placement="left-start">
          <button class="tools-section" title="分享">
            <i class="yk-info_share"></i>
            <div class="tools-name">分享</div>
          </button>
        </YorkbbsWechatSharePopover>
      </li>
      <li class="tools-item" v-if="phoneShareVisible">
        <YorkbbsPhoneSharePopover placement="left-start">
          <button class="tools-section" title="手机">
            <i class="yk-iphone-line"></i>
            <div class="tools-name">手机</div>
          </button>
        </YorkbbsPhoneSharePopover>
      </li>
      <li class="tools-item" v-if="reportVisible">
        <button class="tools-section" title="举报" @click="$emit('report')">
          <i class="yk-info_danger"></i>
          <div class="tools-name">举报</div>
        </button>
      </li>
    </ul>
  </section>
</template>
<script>
import YorkbbsPhoneSharePopover from '@/common/popover-share-phone.vue';
import YorkbbsWechatSharePopover from '@/common/popover-share-wechat.vue';
export default {
  name: 'ToolsShare',
  components: { YorkbbsPhoneSharePopover, YorkbbsWechatSharePopover },
  props: {
    // 是否显示收藏
    favoriteVisible: { type: Boolean, default: true },
    // 是否显示微信分享
    wechatShareVisible: { type: Boolean, default: true },
    // 是否显示手机分享
    phoneShareVisible: { type: Boolean, default: true },
    // 是否显示举报
    reportVisible: { type: Boolean, default: true },
    // 是否已收藏
    isFavorite: [Boolean, Number],
    // 收藏数量
    favoriteNum: Number,
  },
};
</script>
<style lang="scss" scoped>
.tools {
  width: 100px;
  text-align: center;
  position: fixed;
  left: 50%;
  transform: translateX(-640px);
  top: 230px;
  z-index: 1;
}
.tools-item {
  &:not(:first-child) {
    margin-top: 10px;
  }
  &:hover {
    opacity: 0.8;
  }
  &.active {
    color: var(--primary-color);
  }
}
.tools-name {
  font-size: 12px;
  line-height: 17px;
  margin-top: 2px;
  text-align: center;
}
.tools-section {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  i {
    font-size: 20px;
  }
  &:hover {
    background-color: #f8f8f8;
  }
}

.tools-favorite {
  position: relative;
  padding-bottom: 18px;
  margin-bottom: 14px;
  &::after {
    content: '';
    width: 20px;
    border-top: 1px solid #e7e7e7;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }
}

.tools-favorite__item {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: #f8f8f8;
  i {
    font-size: 20px;
  }
  &.active {
    color: var(--primary-color);
  }
  &:hover {
    opacity: 0.8;
  }
}
.tools-favorite__num {
  font-size: 12px;
  line-height: 17px;
  margin-top: 5px;
  &.active {
    color: var(--primary-color);
  }
}
</style>
